<template>
  <div class="headingLv1" :class="{ disableMargin: disableMargin }">
    <h1 class="u-containar">
      {{ text }}
    </h1>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HeadingLv1',

  props: {
    text: String,
    disableMargin: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.disableMargin {
  margin-bottom: 0px !important;
}
.headingLv1 {
  display: flex;
  align-items: center;
  min-height: 100px;
  background-color: var.$color-secondary;
  margin-bottom: 32px;
  @include mixins.media() {
    margin-bottom: 40px;
  }

  h1 {
    width: 100%;
    padding-top: 32px;
    padding-bottom: 32px;
    font-size: 2.2rem;
    font-weight: 500;
    line-height: 1.5;

    @include mixins.media() {
      font-size: 2.4rem;
    }
  }
}
</style>
